import React from 'react';
import { useSelector } from 'react-redux';
import { OverlaySpinner } from '../spinner/overlay-spinner';

export const StyledGlobalSpinner = () => {
  const overlaySpinner = useSelector((state) => state.notification.overlaySpinner);

  return <OverlaySpinner open={overlaySpinner} />;
};
